import { Action } from 'helpers/action-helpers';
import { OperationItem } from 'types/operation-item';
import { NmvsActionType } from 'types/nmvs-action-type';
import { Guid } from 'types/guid';

export const ADD_OPERATION_ITEM = 'AddOperationItemAction';
export const LIST_OPERATION_ITEMS = 'ListOperationItemsAction';
export const SET_OPERATION_ITEMS = 'SetOperationItemsAction';
export const UPDATE_OPERATION_ITEM = 'UpdateOperationItemAction';
export const SET_OPERATION_ITEM = 'SetOperationItemAction';
export const SET_SELECTED_CLIENT_TRANSACTION_ID = 'SetSelectedClientTransactionIdAction';

export class AddOperationItemAction extends Action {
  constructor(public operationItem: OperationItem) {
    super(ADD_OPERATION_ITEM);
  }
}

export class ListOperationItemsAction extends Action {
  constructor() {
    super(LIST_OPERATION_ITEMS);
  }
}

export class SetOperationItemsAction extends Action {
  constructor(
    public pendingRows: OperationItem[],
    public completedRows: OperationItem[],
    public nmvsActionType: NmvsActionType = NmvsActionType.Unknown) {
    super(SET_OPERATION_ITEMS);
  }
}

export class UpdateOperationItemAction extends Action {
  constructor(public clientTransactionId: Guid) {
    super(UPDATE_OPERATION_ITEM);
  }
}

export class SetOperationItemAction extends Action {
  constructor(public clientTransactionId: Guid, public operationItem: OperationItem) {
    super(SET_OPERATION_ITEM);
  }
}

export class SetSelectedClientTransactionIdAction extends Action {
  constructor(public clientTransactionId: Guid) {
    super(SET_SELECTED_CLIENT_TRANSACTION_ID);
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/actions.ts